module.exports = __webpack_public_path__ + "img/CAST服务认证证书-英文.33baf3ed.jpg";